import {handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import classes from 'animate.css'
import classNames from 'classnames'
import React from 'react'
import {BI_SOURCE_PAGE} from '../../../../../../../../commons/bi/constants'
import cn from '../../../../classnames.scss'
import s from './add-to-calendar.scss'
import {AddToCalendarProps} from './interfaces'

export class AddToCalendar extends React.Component<AddToCalendarProps, {optionsVisible: boolean}> {
  state = {optionsVisible: false}

  onAddCalendarClick = () => {
    this.setState({optionsVisible: !this.state.optionsVisible})
    this.props.onClick()
  }

  render() {
    const {buttonText, className = '', dataHook = ''} = this.props
    const {optionsVisible} = this.state

    return (
      <div data-hook={dataHook}>
        <button
          className={classNames(className, {[s.optionsSpacing]: optionsVisible})}
          data-hook="add-to-calendar"
          aria-expanded={optionsVisible}
          onClick={this.onAddCalendarClick}
        >
          {buttonText}
        </button>
        {optionsVisible ? this.getCalendarOptions() : null}
      </div>
    )
  }

  private getCalendarOptionClasses() {
    return `${s.calendarOption} ${classes.animate__fadeInUp}`
  }

  private getCalendarOptions() {
    const {calendarLinks, t} = this.props

    return (
      <div className={classNames(s.calendarOptions, cn.formTitleColor, cn.formLabelsFont)}>
        <a
          target="_blank"
          rel="noreferrer"
          href={calendarLinks.google}
          className={this.getCalendarOptionClasses()}
          data-hook="calendar-google"
          tabIndex={0}
          aria-label={t('a11y.calendarButtonLabel', {
            button: 'Google Calendar',
          })}
          onClick={() => this.props.onOptionClick({origin: 'Google', sourcePage: BI_SOURCE_PAGE.ORDER_SUCCESS})}
          onKeyPress={handleKeyPressEnterOrSpace(() => window.open(calendarLinks.google))}
        >
          Google
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href={calendarLinks.ics}
          className={`${this.getCalendarOptionClasses()} ${s.delayAnimationHalf}`}
          data-hook="calendar-outlook"
          tabIndex={0}
          aria-label={t('a11y.calendarButtonLabel', {
            button: 'Outlook',
          })}
          onClick={() => this.props.onOptionClick({origin: 'Outlook', sourcePage: BI_SOURCE_PAGE.ORDER_SUCCESS})}
          onKeyPress={handleKeyPressEnterOrSpace(() => window.open(calendarLinks.ics))}
        >
          Outlook
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href={calendarLinks.ics}
          className={`${this.getCalendarOptionClasses()} ${s.delayAnimationOne}`}
          data-hook="calendar-ical"
          tabIndex={0}
          aria-label={t('a11y.calendarButtonLabel', {
            button: 'iCal',
          })}
          onClick={() => this.props.onOptionClick({origin: 'iCal', sourcePage: BI_SOURCE_PAGE.ORDER_SUCCESS})}
          onKeyPress={handleKeyPressEnterOrSpace(() => window.open(calendarLinks.ics))}
        >
          iCal
        </a>
      </div>
    )
  }
}
